import React from "react";
import { getToolTipAttributes } from "../../../../utils/tooltip";
import UserAvatar from "../UserAvatar";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";

const MAX_VISIBLE = 3;

const ActivityCell = ({ actions }) => {
  const validActions = actions?.filter((a) => a.name && a.name.trim() !== "") || [];

  if (validActions.length === 0) {
    return <span className="font_size_xsmall color_disabled">No activity</span>;
  }

  // Helper to get Icon and Color based on action string
  const getActionVisuals = (actionType) => {
    const type = actionType ? actionType.toUpperCase() : "";
    switch (type) {
      case "APPROVE":
      case "APPROVED":
        return { icon: "check", bg: "#10B981", tooltip: "Approved" }; // Green
      case "REJECT":
      case "REJECTED":
        return { icon: "close", bg: "#EF4444", tooltip: "Rejected" }; // Red
      case "INITIATED":
        return { icon: "add", bg: "#3B82F6", tooltip: "Initiated" }; // Blue
      case "PROMOTE":
      case "PROMOTED":
        return { icon: "rocket_launch", bg: "#8B5CF6", tooltip: "Promoted" }; // Purple
      default:
        return { icon: "history", bg: "#6B7280", tooltip: "Activity" }; // Gray
    }
  };

  const visibleActions = validActions.slice(0, MAX_VISIBLE);
  const remainingCount = validActions.length - MAX_VISIBLE;

  return (
    <div className="d_flex align_center pl_2">
      {" "}
      {/* pl_2 to account for first negative margin if needed, usually not needed if stacking right */}
      {visibleActions.map((action, i) => {
        const config = getActionVisuals(action.action);
        const tooltipText = `${action.name}: ${config.tooltip} - ${new Date(action.timestamp).toLocaleDateString()}`;

        return (
          <div
            key={i}
            className="position_relative"
            style={{
              marginLeft: i === 0 ? 0 : "-10px", // Stack overlap
              zIndex: visibleActions.length - i + 1, // First one on top
              borderRadius: "50%",
              backgroundColor: "#FFF", // White bg behind avatar ensures clean overlap
              padding: "2px" // Creates the whitespace between avatars
            }}
            {...getToolTipAttributes(tooltipText)}
          >
            <UserAvatar name={action.name} size="28px" />

            {/* Status Badge Overlay */}
            <div
              className="position_absolute d_flex justify_center align_center"
              style={{
                bottom: "-2px",
                right: "-2px",
                width: "12px",
                height: "12px",
                backgroundColor: config.bg,
                borderRadius: "50%",
                border: "2px solid #FFFFFF", // Important: Cuts the badge out from the avatar
                boxSizing: "content-box", // Ensures border doesn't shrink the 14px size
                boxShadow: "0 1px 2px rgba(0,0,0,0.1)"
              }}
            >
              <MaterialIcon
                name={config.icon}
                style={{
                  fontSize: "10px", // Tiny icon
                  color: "#FFFFFF",
                  fontWeight: "bold"
                }}
              />
            </div>
          </div>
        );
      })}
      {/* Counter for hidden items */}
      {remainingCount > 0 && (
        <div
          className="d_flex justify_center align_center border_radius_circle bg_light_gray color_secondary"
          style={{
            width: "28px",
            height: "28px",
            fontSize: "11px",
            fontWeight: 600,
            border: "2px solid #FFFFFF", // Match the avatar border style
            marginLeft: "-10px",
            zIndex: 0,
            boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
          }}
          {...getToolTipAttributes(
            `${remainingCount} more:\n${validActions
              .slice(MAX_VISIBLE)
              .map((a) => `${a.name} (${a.action})`)
              .join("\n")}`
          )}
        >
          +{remainingCount}
        </div>
      )}
    </div>
  );
};

export default ActivityCell;
